import { projectIqTokens } from "apps/project-iq/theme/projectIqTokens";
import {
  MILESTONE_STATUS_LABELS,
  RAID_STATUS_LABELS,
} from "apps/project-iq/constants/planStatusLabels";
import { designTokens } from "theme/customTheme";

export type PillToneKey =
  "green" | "blue" | "neutral" | "red" | "orange" | "typeNeutral";

export interface IPortfolioPillTone {
  label: string;
  toneKey: PillToneKey;
  background: string;
  color: string;
}

const pillPairGreen = {
  toneKey: "green" as const,
  background: "#dff5ee",
  color: "#0b7d6a",
};
const pillPairBlue = {
  toneKey: "blue" as const,
  background: "#e3f0fb",
  color: "#1f6fb2",
};
const pillPairNeutral = {
  toneKey: "neutral" as const,
  background: projectIqTokens.line2,
  color: projectIqTokens.muted,
};
const pillPairRed = {
  toneKey: "red" as const,
  background: "#fde8e6",
  color: "#c0392b",
};
const pillPairOrange = {
  toneKey: "orange" as const,
  background: "#fdf1dd",
  color: "#b87913",
};
const pillPairTypeNeutral = {
  toneKey: "typeNeutral" as const,
  background: projectIqTokens.bg,
  color: projectIqTokens.muted,
};

export const dashboardTokens = {
  indent: {
    portfolio: designTokens.spacing[4],
    workspace: designTokens.spacing[10],
    detail: designTokens.spacing[16],
  },

  page: {
    maxWidth: "1180px",
    padding: `${designTokens.spacing[8]} ${designTokens.spacing[8]} ${designTokens.spacing[16]}`,
  },

  grid: {
    workspaceRow: "minmax(220px,1fr) 132px 132px 132px 132px 104px 104px 104px",
    milestones: "1fr 110px 130px",
    deliverables: "1fr 110px 130px",
    raid: "1fr 120px 110px 110px 130px",
  },

  ragDot: {
    size: "14px",
    tone: {
      green: "#1f8a5b",
      amber: "#e0a82e",
      red: "#c0392b",
    },
  },

  pillPair: {
    green: pillPairGreen,
    blue: pillPairBlue,
    neutral: pillPairNeutral,
    red: pillPairRed,
    orange: pillPairOrange,
    typeNeutral: pillPairTypeNeutral,
  },

  pill: {
    fontSize: "11px",
    padding: "3px 10px",
  },

  raidNameLineHeight: "1.45",

  card: {
    radius: "14px",
  },
  chevronTransition: designTokens.transition.fast,

  status: {
    milestone: {
      done: { label: MILESTONE_STATUS_LABELS.done, ...pillPairGreen },
      active: { label: MILESTONE_STATUS_LABELS.in_progress, ...pillPairBlue },
      upcoming: {
        label: MILESTONE_STATUS_LABELS.not_started,
        ...pillPairNeutral,
      },
    },
    raidSeverity: {
      high: { label: "High", ...pillPairRed },
      med: { label: "Medium", ...pillPairOrange },
      low: { label: "Low", ...pillPairNeutral },
    },
    raidLifecycle: {
      open: { label: RAID_STATUS_LABELS.not_started, ...pillPairRed },
      mitigating: { label: RAID_STATUS_LABELS.in_progress, ...pillPairOrange },
      closed: { label: RAID_STATUS_LABELS.closed, ...pillPairGreen },
    },
    raidTypeNeutral: pillPairTypeNeutral,
  },
} as const;
